import { render } from "./SassIcon.vue?vue&type=template&id=4a34ed2e&scoped=true"
import script from "./SassIcon.vue?vue&type=script&lang=js"
export * from "./SassIcon.vue?vue&type=script&lang=js"

import "./SassIcon.vue?vue&type=style&index=0&id=4a34ed2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a34ed2e"]])

export default __exports__